export default __webpack_public_path__ + "static/media/Standard16.941776df.png";